
export const mockFacilities = [
  {
    id: 1,
    name: 'Emin Termal',
    slug: 'emin-termal',
    location: 'Yalova',
    description: 'Yalova\'nın kalbinde, şifalı termal suları ve modern spa imkanları ile huzurlu bir tatil deneyimi. Termal havuzlar, masaj hizmetleri ve sağlıklı yaşam merkezi.',
    image: 'https://public.readdy.ai/ai/img_res/4d53c45b33f168cf87de465a3abdcd3a.jpg',
    listing_count: 14,
    amenities: ['Termal Havuz', 'Spa Merkezi', 'Masaj', 'Sauna', 'Fitness', 'Restoran'],
  },
  {
    id: 2,
    name: 'Limak Limra Hotel',
    slug: 'limak-limra',
    location: 'Antalya - Kemer',
    description: 'Akdeniz\'in incisi Kemer\'de özel plaj, aquapark ve ultra her şey dahil konsepti ile lüks tatil. Aileler için ideal seçim.',
    image: 'https://readdy.ai/api/search-image?query=limak%20limra%20hotel%20kemer%20antalya%20luxury%20beach%20resort%20mediterranean%20sea%20private%20beach%20palm%20trees%20pools%20modern%20architecture%20turkey%20real%20photo&width=800&height=600&seq=limra-facility-main&orientation=landscape',
    listing_count: 1,
    amenities: ['Özel Plaj', 'Aquapark', 'Spa', 'Çocuk Kulübü', 'Restoran', 'Spor Tesisleri'],
  },
  {
    id: 3,
    name: 'Rixos Premium Belek',
    slug: 'rixos-premium-belek',
    location: 'Antalya - Belek',
    description: 'Belek\'in en prestijli tesislerinden biri. Golf sahası, özel plaj ve dünya standartlarında VIP hizmet.',
    image: 'https://readdy.ai/api/search-image?query=rixos%20premium%20belek%20antalya%20luxury%20resort%20hotel%20private%20beach%20golf%20course%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=800&height=600&seq=rixos-facility-main&orientation=landscape',
    listing_count: 1,
    amenities: ['Golf Sahası', 'Özel Plaj', 'VIP Spa', 'Butler Hizmeti', 'Gourmet Restoran'],
  },
  {
    id: 4,
    name: 'Hillside Beach Club',
    slug: 'hillside-beach-club',
    location: 'Muğla - Fethiye',
    description: 'Fethiye\'nin eşsiz doğasında butik otel konsepti. Özel koy, organik mutfak ve huzurlu tatil deneyimi.',
    image: 'https://readdy.ai/api/search-image?query=hillside%20beach%20club%20fethiye%20mugla%20boutique%20resort%20private%20bay%20turquoise%20sea%20pine%20trees%20luxury%20bungalows%20turkey%20real%20photo&width=800&height=600&seq=hillside-facility-main&orientation=landscape',
    listing_count: 1,
    amenities: ['Özel Koy', 'Organik Mutfak', 'Bungalow', 'Su Sporları', 'Spa'],
  },
  {
    id: 5,
    name: 'Maxx Royal Belek',
    slug: 'maxx-royal-belek',
    location: 'Antalya - Belek',
    description: 'Dünyanın en iyi otellerinden biri. Ultra lüks villalar, özel plaj ve eşsiz hizmet kalitesi.',
    image: 'https://readdy.ai/api/search-image?query=maxx%20royal%20belek%20antalya%20ultra%20luxury%20resort%20hotel%20private%20beach%20villas%20pools%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=800&height=600&seq=maxx-facility-main&orientation=landscape',
    listing_count: 1,
    amenities: ['Özel Villa', 'Butler Hizmeti', 'Gourmet', 'Golf', 'VIP Spa'],
  },
  {
    id: 6,
    name: 'Voyage Belek',
    slug: 'voyage-belek',
    location: 'Antalya - Belek',
    description: 'Belek\'in köklü tesislerinden biri. Geniş plaj, aquapark ve aile dostu tatil imkanları.',
    image: 'https://readdy.ai/api/search-image?query=voyage%20belek%20golf%20spa%20antalya%20resort%20hotel%20beach%20pools%20aquapark%20palm%20trees%20mediterranean%20turkey%20real%20photo&width=800&height=600&seq=voyage-facility-main&orientation=landscape',
    listing_count: 1,
    amenities: ['Geniş Plaj', 'Aquapark', 'Golf', 'Çocuk Kulübü', 'Spa'],
  },
];
